import { backofficeDialogOptions } from 'src/app/layout/shared/dialogs/backoffice-dialog.options';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { el } from 'date-fns/locale';
import { NgxDropzonePreviewComponent } from 'ngx-dropzone';
import { ImageConstraints } from 'src/app/core/models/store-templates/image-constraints';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MultimediaGalleryModalComponent } from '../multimedia-gallery-modal/multimedia-gallery-modal.component';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-custom-dropzone-preview',
  templateUrl: './custom-dropzone-preview.component.html',
  styleUrls: ['./custom-dropzone-preview.component.scss'],
  providers: [
    {
      provide: NgxDropzonePreviewComponent,
      useExisting: CustomDropzonePreviewComponent
    }
  ]
})
export class CustomDropzonePreviewComponent extends NgxDropzonePreviewComponent implements OnInit {
  @Input() filesUrl:any;
  @Input() singleFileUrl:any;
  @Input() imageSize?: ImageConstraints;
  @Input() allowReorder: boolean = false;

  @Output() closeFileEvent = new EventEmitter<string>();
  @Output() cancelUploadEvent = new EventEmitter<number>();
  @Output() aiEnhanceEvent = new EventEmitter<{index: number, url: string}>();
  @Output() reorderEvent = new EventEmitter<any[]>();
  
  constructor(sanitizer: DomSanitizer, private modalService: NgbModal) {
    super(sanitizer);
   }

  drop(event: CdkDragDrop<any[]>) {
    if (this.allowReorder && this.filesUrl) {
      moveItemInArray(this.filesUrl, event.previousIndex, event.currentIndex);
      this.reorderEvent.emit(this.filesUrl);
    }
  }

  ngOnInit(): void {
  }

  // Retourne les styles CSS à appliquer à l'image basés sur imageSize
   
  getImageStyles(): any {
   /* if (!this.imageSize || !this.imageSize.required) {
      return {};
    }*/

    const styles: any = {};
    
    // Appliquer les dimensions si elles sont définies
    /*if (this.imageSize.width && this.imageSize.height) {
      styles.width = this.imageSize.width + 'px';
      styles.height = this.imageSize.height + 'px';
    }
    
    // Appliquer le ratio d'aspect si défini
    if (this.imageSize.aspect_ratio) {
      const [width, height] = this.imageSize.aspect_ratio.split(':').map(Number);
      if (width && height) {
        styles.aspectRatio = this.imageSize.aspect_ratio;
        // Si on a un ratio mais pas de dimensions exactes, on peut définir une largeur max
        if (!styles.width) {
          styles.maxWidth = '100%';
          styles.height = 'auto';
        }
      }
    }*/
    
    // Assurer que l'image s'adapte bien
    styles.objectFit = 'cover';
    styles.objectPosition = 'center';
    
    return styles;
  }

  // Retourne le nom de l'image et sa taille pour le tooltip
  getImageInfo(): string {
    let tooltip = '';
    
    if (this.singleFileUrl && this.singleFileUrl.value) {
      // Extraire le nom du fichier de l'URL
      const url = this.singleFileUrl.value;
      const fileName = url.split('/').pop() || url;
      tooltip = fileName;
      
      // Ajouter les informations de taille si disponibles
      if (this.imageSize) {
        tooltip += `\n${this.imageSize.width} × ${this.imageSize.height}px`;
        if (this.imageSize.aspect_ratio) {
          tooltip += ` (${this.imageSize.aspect_ratio})`;
        }
      }
    }
    
    return tooltip;
  }


  removeImage(event, index){
    event.stopPropagation();
    if(!this.singleFileUrl){
      this.filesUrl[index].loading = true;
      this.closeFileEvent.emit(index);
    }
    else{
      this.singleFileUrl.value = "";
      this.closeFileEvent.emit(index);
    }
  }

  cancelUpload(event, index) {
    event.stopPropagation();
    this.cancelUploadEvent.emit(index);
  }

  enhanceWithAI(event: Event, index: number) {
    event.stopPropagation();
    const url = this.filesUrl?.[index]?.url || '';
    this.aiEnhanceEvent.emit({ index, url });
  }

  /**
   * Opens the gallery modal to browse through images.
   */
  openFile(event: Event, index: number): void {
    event.stopPropagation();

    // Un fichero muerto abriria el visor con otro icono roto dentro. El clic no hace nada;
    // el boton de borrar sigue disponible encima del placeholder.
    const clickedUrl = this.filesUrl ? this.filesUrl?.[index]?.url : this.singleFileUrl?.value;
    if (this.isBroken(clickedUrl)) return;

    let mediaItems = [];
    if (this.filesUrl) {
      mediaItems = this.filesUrl;
    } else if (this.singleFileUrl && this.singleFileUrl.value) {
      mediaItems = [this.singleFileUrl];
    }

    if (mediaItems.length === 0) return;

    const modalRef = this.modalService.open(MultimediaGalleryModalComponent, backofficeDialogOptions('gallery', 'workspace'));

    modalRef.componentInstance.mediaItems = mediaItems;
    modalRef.componentInstance.startIndex = index;
  }

  /**
   * URLs cuyo fichero ya no existe en el servidor.
   *
   * Se indexa por URL, no por indice ni por objeto: asi vale igual para la rama multiple
   * (objetos ResourcesRS) que para la single (singleFileUrl.value, que es un string), marca
   * los dos huecos si la misma URL muerta se repite, y al subir un fichero nuevo la URL cambia,
   * con lo que no hay que resetear nada.
   */
  private readonly brokenUrls = new Set<string>();

  isBroken(url?: string): boolean {
    return !!url && this.brokenUrls.has(url);
  }

  /**
   * Angular retira el <img> del DOM en el siguiente ciclo de deteccion de cambios, asi que la
   * carga no se reintenta y no hay bucle.
   */
  onImageError(url?: string): void {
    if (url) {
      this.brokenUrls.add(url);
    }
  }

  /**
   * Helper to determine if a URL represents an image based on common extensions.
   */
  isImage(url: string): boolean {
    if (!url) return false;
    const extension = url.split('?')[0].split('.').pop()?.toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    return imageExtensions.includes(extension || '');
  }
}
